import styled from 'styled-components';
import { pageHorizontalPadding } from '../styles/constants';

const FullWidthWrapper = styled.div`
  width: calc(100% + ${pageHorizontalPadding} + ${pageHorizontalPadding});
`;

export default FullWidthWrapper;
